import { useDispatch } from "react-redux";
import {
  setBonusGames,
  setExcludeDemoMode,
  setFavoriteGames,
  setGameId,
  setHitGames,
  setProviders,
  setProvidersGames,
  setLiveGames
} from "../../store/gamesSlice";
import { setBanners, setCasinoField } from "../../store/commonSlice";
import { useEffect } from "react";
import { API_CASINO } from "../../api/casino";
import { checkUrlBotTg, DEBUG, ENUM_LCS_NAME, ENUM_MODE_GAME, TEST_MODE } from "../../store/enums";
import { testCasinoInfo } from "../../store/testConst";
import { useLocalStorage } from "usehooks-ts";
import { getParamFromUrl, updateImageUrl } from "../../utils/utils";
import { setErrorInfo, setMainLoader } from "../../store/siteSlice";
import { checkGameIsLive } from "../../utils/utilsLiveGame";

const MINUTES = 60;
// const MINUTES = 0.1;

export default function useFillCasino() {
  const dispatch = useDispatch();
  const [startR, setStartR] = useLocalStorage(ENUM_LCS_NAME.startR, "");
  const [pbParams, setPbParams] = useLocalStorage(ENUM_LCS_NAME.pbParams, "");
  const [casinoInfo, setCasinoInfo] = useLocalStorage(ENUM_LCS_NAME.casinoInfo, {});

  const getMinutes = (mn) => mn * 60000;

  // getProviders
  const getProviders = async (
    gameCategories,
    gameHits,
    updateFavorite,
    favoritesId,
    excludeDemoMode
  ) => {
    const addLiveGames = (id, game) => {
      if (checkGameIsLive(game)) liveGames[id] = game;
    };

    const mode = getParamFromUrl("mode");
    const isDemo = mode === ENUM_MODE_GAME.demo;

    const providersGamesById = {};
    const validGameHitsById = {};
    const providerCount = {};
    const favoriteGames = [];
    const providersSet = new Set([]);
    const liveGames = [];

    // CRUTCH // сортировка должна быть ссервера
    let curIndx = 0;

    gameHits.forEach((game) => {
      if (isDemo && excludeDemoMode?.includes(game.providerName)) return;
      const id = game.game_id;
      const image = updateImageUrl(game.image); // CRUTCH
      const gameInfo = { ...game, image, curIndx };
      const update = game.favorites && updateFavorite;
      validGameHitsById[id] = gameInfo;

      if (providersGamesById[id]) return;

      providersGamesById[id] = gameInfo;

      if (update || favoritesId?.includes(id)) favoriteGames[id] = { ...game, image };

      addLiveGames(id, gameInfo);
      curIndx++;
    });

    gameCategories.forEach((category) => {
      // fill games
      category.games.forEach((el) => {
        const id = el.game_id;
        // CRUTCH
        // const image = el.image?.replace("r.gamesstatic.com", "gamesstatic.com");
        const image = updateImageUrl(el.image);
        const game = { ...el, groupId: category.id, image, curIndx };

        if (el.hit) {
          if (!validGameHitsById[id]) {
            validGameHitsById[id] = game;
          } else if (game.priority) {
            validGameHitsById[id] = { ...validGameHitsById[id], priority: game.priority };
          }
        }

        const update = game.favorites && updateFavorite;
        if (update || favoritesId?.includes(id)) favoriteGames[id] = game;

        if (providersGamesById[id]) return;
        if (isDemo && excludeDemoMode?.includes(el.provider)) return;
        providersGamesById[id] = game;
        addLiveGames(id, game);

        curIndx++;
      });
    });

    // у кого приоритет выше тот первее
    const providersGames = Object.values(providersGamesById);
    const validGameHits = Object.values(validGameHitsById);

    providersGames.sort((l, r) => l.curIndx - r.curIndx);
    providersGames.sort((l, r) => l.priority - r.priority);
    validGameHits.sort((l, r) => l.curIndx - r.curIndx);
    validGameHits.sort((l, r) => l.priority - r.priority);
    liveGames.sort((l, r) => l.curIndx - r.curIndx);
    liveGames.sort((l, r) => l.priority - r.priority);

    dispatch(setGameId(providersGamesById));
    dispatch(setProvidersGames(providersGames));
    dispatch(setExcludeDemoMode(excludeDemoMode));
    dispatch(setFavoriteGames(favoriteGames.filter((el) => el)));
    dispatch(
      setLiveGames(
        liveGames.filter((el) => el)
        // .map((el) => ({
        //   game_id: el.game_id,
        //   groupId: el.groupId,
        //   image: el.image,
        //   name: el.name,
        //   provider: el.provider,
        //   type: el.type,
        //   uuid: el.uuid
        // }))
      )
    );
    dispatch(setHitGames(validGameHits));

    // providers
    providersGames.forEach((el) => {
      const provider = el.provider;
      providerCount[provider] = (providerCount[provider] || 0) + 1;
      providersSet.add(provider);
    });

    const providers = [...providersSet].map((provider) => ({
      name: provider,
      count: providerCount[provider] || 0
    }));
    dispatch(setProviders(providers));
  };

  // fillCasinoInfo - заполнение стора инфой полученный от сервера при инициализации
  const fillCasinoInfo = (data, updateFavorite, favoritesId) => {
    const gameCategories = data.gameCategories;
    const bonusGames = data.bonusGames;
    const banners = [...(data?.banners || [])];
    const isTgBot = checkUrlBotTg();

    getProviders(gameCategories, data.gameHits, updateFavorite, favoritesId, data.excludeFromDemo);

    dispatch(setCasinoField(data));
    dispatch(setBonusGames(bonusGames));

    let newBanners = banners.sort((l, r) => l.position - r.position);
    // если мы уже в боте убираем баннеры которые ведут на бота
    if (isTgBot) {
      newBanners = newBanners.filter((el) => !el.makeBotLink);
    }
    dispatch(setBanners(newBanners));
  };

  // getStartR - получение start_r
  const getStartR = () => {
    if (startR) return startR;
    const tempStartR = getParamFromUrl("start");
    if (tempStartR) setStartR(tempStartR);

    return tempStartR;
  };

  // getPbParams - получение pb_params
  const getPbParams = () => {
    if (pbParams) return pbParams;

    const queryParams = new URLSearchParams(location.search);
    queryParams.delete("start");
    queryParams.delete("mode");
    queryParams.delete("sessionId");

    const tempBpParams = queryParams.toString();
    const base64EncodedQueryString = btoa(tempBpParams);
    if (tempBpParams) setPbParams(base64EncodedQueryString);
    return tempBpParams;
  };

  useEffect(() => {
    const start_r = getStartR() || "";
    const pb_params = getPbParams() || "";

    if (TEST_MODE) {
      const favoritesId = JSON.parse(localStorage.getItem(ENUM_LCS_NAME.favoritesId)) || [];
      fillCasinoInfo(testCasinoInfo, false, favoritesId);
      dispatch(setMainLoader(false));
      return;
    }

    if (+casinoInfo?.time + getMinutes(MINUTES) > +new Date()) {
      const favoritesId = JSON.parse(localStorage.getItem(ENUM_LCS_NAME.favoritesId)) || [];
      try {
        fillCasinoInfo(casinoInfo.info, false, favoritesId);
      } catch (e) {
        dispatch(setErrorInfo(true));
      }

      // что бы успел прогрузиться сайт
      setTimeout(() => dispatch(setMainLoader(false)), 700);
      return;
    }

    API_CASINO.info({ start_r, pb_params })
      .then((e) => {
        setCasinoInfo({ time: +new Date(), info: e.data });
        if (!e.data) dispatch(setErrorInfo(true));
        fillCasinoInfo(e.data, true);

        if (DEBUG && e.data.error) console.log("error casino info", e.data?.error);
      })
      .catch((e) => {
        dispatch(setErrorInfo(true));
        if (DEBUG) console.log("catch casino info ", e);
      })
      .finally(() => {
        dispatch(setMainLoader(false));
      });
  }, []);
}
